/* BLACK CLAW お気に入り(ウィッシュリスト) — localStorage方式 / アプリ不要
 * 保存キー: bc_wishlist_v1
 * 公開API: window.BCWishlist
 * ボタンは既存テンプレを書き換えず、data属性を見てJSで注入する。
 */
(function () {
  if (window.BCWishlist) { return; }

  var KEY = 'bc_wishlist_v1';
  var MAX = 100;
  var HEART = '<svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64"><path d="M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44Z"/></svg>';

  if (!window.BCWishlistUrl) { window.BCWishlistUrl = '/pages/wishlist'; }

  /* ---------- store ---------- */

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) { return []; }
  }

  function persist(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    sync();
    try {
      document.dispatchEvent(new CustomEvent('bc:wishlist:change', { detail: { items: read() } }));
    } catch (e) {}
  }

  function has(id) {
    id = String(id);
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === id) { return true; }
    }
    return false;
  }

  function remove(id) {
    id = String(id);
    persist(read().filter(function (i) { return String(i.id) !== id; }));
  }

  function add(item) {
    var list = read().filter(function (i) { return String(i.id) !== String(item.id); });
    item.ts = Date.now();
    list.unshift(item);
    persist(list);
  }

  function toggle(item) {
    if (has(item.id)) { remove(item.id); return false; }
    add(item);
    return true;
  }

  /* ---------- helpers ---------- */

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function each(selector, fn) {
    qsa(document, selector).forEach(fn);
  }

  /* 同じ値の再代入を避ける(MutationObserverの無限ループ防止) */
  function setText(el, value) {
    if (el && el.textContent !== value) { el.textContent = value; }
  }

  function textToCents(text) {
    if (!text) { return 0; }
    var m = String(text).replace(/,/g, '').match(/[0-9]+(\.[0-9]+)?/);
    if (!m) { return 0; }
    var n = parseFloat(m[0]);
    if (!n || isNaN(n)) { return 0; }
    return Math.round(n * 100);
  }

  function imgSrc(img) {
    if (!img) { return ''; }
    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    return src.replace('{width}', '400');
  }

  /* ---------- UI ---------- */

  function sync() {
    var n = read().length;
    each('[data-bc-wish]', function (btn) {
      var active = has(btn.getAttribute('data-wish-id'));
      if (active) { btn.classList.add('is-active'); } else { btn.classList.remove('is-active'); }
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');
      setText(btn.querySelector('[data-wish-label]'), active ? 'お気に入り登録済み' : 'お気に入りに追加');
    });
    each('[data-bc-wish-count]', function (el) {
      setText(el, n > 99 ? '99+' : String(n));
      if (n > 0) { el.classList.add('is-visible'); } else { el.classList.remove('is-visible'); }
    });
  }

  function toast(message, linkText) {
    var el = document.querySelector('.bc-wish-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bc-wish-toast';
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (linkText) {
      var a = document.createElement('a');
      a.href = window.BCWishlistUrl;
      a.textContent = linkText;
      el.appendChild(a);
    }
    el.classList.add('is-visible');
    clearTimeout(el._bcTimer);
    el._bcTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  function makeButton(data, variant) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bc-wish bc-wish--' + variant;
    b.setAttribute('data-bc-wish', '');
    b.setAttribute('data-wish-id', data.id || '');
    b.setAttribute('data-wish-handle', data.handle || '');
    b.setAttribute('data-wish-title', data.title || '');
    b.setAttribute('data-wish-url', data.url || '');
    b.setAttribute('data-wish-price', String(data.price || 0));
    b.setAttribute('data-wish-image', data.image || '');
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', 'お気に入りに追加');
    b.innerHTML = HEART + (variant === 'pdp' ? '<span class="bc-wish__label" data-wish-label>お気に入りに追加</span>' : '');
    return b;
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-wish-id'),
      handle: btn.getAttribute('data-wish-handle'),
      title: btn.getAttribute('data-wish-title'),
      url: btn.getAttribute('data-wish-url'),
      price: parseInt(btn.getAttribute('data-wish-price') || '0', 10),
      image: btn.getAttribute('data-wish-image')
    };
  }

  /* ---------- 商品カードへの注入 ---------- */

  function injectCards() {
    each('.grid-product[data-product-handle]', function (card) {
      if (card.querySelector('.bc-wish--card')) { return; }
      var content = card.querySelector('.grid-product__content');
      if (!content) { return; }

      var link = card.querySelector('.grid-product__link');
      var titleEl = card.querySelector('.grid-product__title');
      var priceEl = card.querySelector('.grid-product__price');
      var img = card.querySelector('.grid__item-image-wrapper img');

      var price = 0;
      if (priceEl) {
        var clone = priceEl.cloneNode(true);
        qsa(clone, '.grid-product__price--original, .grid-product__price--savings, .visually-hidden, .product__unit-price').forEach(function (n) {
          if (n.parentNode) { n.parentNode.removeChild(n); }
        });
        price = textToCents(clone.textContent);
      }

      content.insertBefore(makeButton({
        id: card.getAttribute('data-product-id'),
        handle: card.getAttribute('data-product-handle'),
        title: titleEl ? titleEl.textContent.trim() : '',
        url: link ? link.getAttribute('href') : '',
        price: price,
        image: imgSrc(img)
      }, 'card'), content.firstChild);
    });
  }

  /* ---------- 商品ページへの注入 ---------- */

  function injectPdp() {
    each('.product-section[data-product-handle]', function (sec) {
      if (sec.getAttribute('data-modal') === 'true') { return; }
      if (sec.querySelector('.bc-wish--pdp')) { return; }
      var form = sec.querySelector('form[action*="/cart/add"]');
      if (!form || !form.parentNode) { return; }

      var price = 0;
      try {
        var cur = sec.querySelector('[data-current-variant-json]');
        if (cur && cur.value) { price = JSON.parse(cur.value).price || 0; }
        if (!price) {
          var all = sec.querySelector('[data-variant-json]');
          if (all && all.value) {
            var variants = JSON.parse(all.value);
            if (variants && variants.length) { price = variants[0].price || 0; }
          }
        }
      } catch (e) { price = 0; }

      form.parentNode.appendChild(makeButton({
        id: sec.getAttribute('data-product-id'),
        handle: sec.getAttribute('data-product-handle'),
        title: sec.getAttribute('data-product-title'),
        url: sec.getAttribute('data-product-url'),
        price: price,
        image: (sec.getAttribute('data-img-url') || '').replace('{width}', '400')
      }, 'pdp'));
    });
  }

  function inject() {
    try { injectCards(); } catch (e) {}
    try { injectPdp(); } catch (e) {}
    sync();
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var target = e.target;
    var btn = target && target.closest ? target.closest('[data-bc-wish]') : null;
    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(itemFromButton(btn));
    btn.classList.remove('bc-wish--pop');
    void btn.offsetWidth;
    if (added) { btn.classList.add('bc-wish--pop'); }
    toast(added ? 'お気に入りに追加しました' : 'お気に入りから削除しました', added ? 'リストを見る' : null);
  }, true);

  var timer = null;
  function injectSoon() {
    clearTimeout(timer);
    timer = setTimeout(inject, 200);
  }

  function init() {
    inject();
    if (window.MutationObserver && document.body) {
      new MutationObserver(injectSoon).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', injectSoon);
  window.addEventListener('pageshow', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); } });

  window.BCWishlist = {
    key: KEY,
    all: read,
    count: function () { return read().length; },
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    sync: sync,
    inject: inject,
    toast: toast
  };
})();
